import React, { FC } from 'react'

import { Link } from 'react-router-dom'
import { Routes } from 'common/constants'
import { TPrivacyPolicyLink } from 'contexts/app-context/types'
import { Button } from 'common/styles/layouts'

import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import { Text } from '@interco/inter-ui/components/Text'

import { PrivacyPolicyLinkContainer } from '../styles/PrivacyPolicyLink.styles'

export const PrivacyPolicyLinkView: FC<TPrivacyPolicyLink> = ({
  title,
  details,
  confirmButton,
}) => (
  <PrivacyPolicyLinkContainer>
    <section>
      <Text variant="headline-h3" color="typography" semiBold as="p">
        {title}
      </Text>
      <Text variant="body-3" color="typography" colorWeight={400} as="p">
        {details}
      </Text>
    </section>
    <Link to={Routes.PRIVACY_POLICY} state={{ from: Routes.PRIVACY_POLICY }}>
      <Button
        size="small"
        variant="secondary"
        id={`privacyPolicyLink-${title}`}
        fullWidth
        icon={<IcChevronRight height={24} width={24} color="var(--secondary500)" />}
        style={{ textAlign: 'center' }}
      >
        {confirmButton}
      </Button>
    </Link>
  </PrivacyPolicyLinkContainer>
)
